import React from "react";
import { Tabs, Tab } from "react-bootstrap";

import Left_panel from "../Left_panel";
import Sub_header from "../Sub_header";

import InvoiceSettings from "./InvoiceSettings";
import GenerateInvoice from "./GenerateInvoice";
import InvoiceList from "./InvoiceList";

const Invoice = () => {
  const [isSidebarOpen, setIsSidebarOpen] = React.useState(false);
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
    const homeSection = document.querySelector(".home-section");
    if (homeSection) {
      homeSection.classList.toggle("sidebar-closed");
    }
  };
  return (
    <>
      <Left_panel isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />

      <section class="home-section">
        <Sub_header />

        <div className="container-fluid mt-3">
          <div className="card shadow-sm border-0">
            <div className="card-header bg-white">
              <h4 className="mb-0 fw-bold">Invoice Management</h4>
            </div>

            <div className="card-body">
              <Tabs
                defaultActiveKey="settings"
                id="invoice-tabs"
                className="mb-4"
              >
                <Tab eventKey="settings" title="Invoice Settings">
                  <InvoiceSettings />
                </Tab>

                <Tab eventKey="generate" title="Generate Invoice">
                  <GenerateInvoice />
                </Tab>

                <Tab eventKey="list" title="Invoice List">
                  <InvoiceList />
                </Tab>
              </Tabs>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Invoice;
